/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import * as _lightColors from './light';
import * as _darkColors from './dark';
export * from './base';
import * as baseColors from './base';
import * as baseColors_1 from './base';
export { baseColors_1 as baseColors };
// FIXME:THEME
const lightMaskColor = {
    lightMaskColor: 'rgba(38,38,38,0.1)'
};
export const lightColors = Object.assign(Object.assign(Object.assign({}, _lightColors), baseColors), lightMaskColor);
export const darkColors = Object.assign(Object.assign(Object.assign({}, _darkColors), baseColors), lightMaskColor);
// Collection of lightColors and darkColors
const colors = Object.assign(Object.assign({}, lightColors), darkColors);
